<template>
    <el-input
        ref="input"
        v-if="permissionsShow"
        :placeholder="vm.$t(placeholder)"
        :maxlength="maxlength"
        :minlength="minlength"
        :clearable="clearable"
        :disabled="disabled"
        :unselectable="isReadonly ? 'on' : ''"
        :rows="rows"
        :autosize="autosize"
        :readonly="isReadonly"
        :validate-event="validateEvent"
        v-model="currentValue"
        :type="type"
        :size="size"
        :autocomplete="autocomplete"
        :style="{ width: width + 'px' }"
        :prefix-icon="prefixIcon"
        :suffix-icon="suffixIcon"
        :resize="resize"
        :autofocus="autofocus"
        :label="label"
        :tabindex="tabindex"
        @blur="_blur"
        @focus="_focus"
        @clear="_clear"
        :change="_change(currentValue)"
    >
        <template slot="prefix">
            <slot name="prefix"></slot>
        </template>
        <template slot="suffix">
            <slot name="suffix"></slot>
        </template>
        <template slot="prepend">
            <slot name="prepend"></slot>
        </template>
        <template slot="append">
            <slot name="append"></slot>
        </template>
    </el-input>
</template>
<script>
export default {
    props: {
        // 默认显示内容
        placeholder: {
            type: String,
            default: function() {
                return 'component.PLEASE_INPUT';
            }
        },
        // 类型 text/textArea
        type: {
            type: String,
            default: function() {
                return 'text';
            }
        },
        // 输入框显示数据
        value: {
            type: [String, Number]
        },
        // 是否禁用
        disabled: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        // 最大输入值
        maxlength: {
            type: Number,
            default: function() {
                if (this.type == 'text') {
                    return 200;
                }
            }
        },
        // 最小输入值
        minlength: Number,
        // 三种类型可选medium / small / mini
        size: {
            type: String,
            default: function() {
                return 'medium';
            }
        },
        // 是否可清空
        clearable: {
            type: Boolean,
            default: function() {
                return true;
            }
        },
        // 输入框行数，只对 type="textarea" 有效
        rows: {
            type: Number,
            default: function() {
                return 3;
            }
        },
        // 自适应内容高度，只对 type="textarea" 有效，可传入对象，如，{ minRows: 2, maxRows: 6 }
        autosize: {
            type: [Boolean, Object],
            default: function() {
                return false;
            }
        },
        // 是否只读
        readonly: Boolean,
        // 输入时是否触发表单的校验
        validateEvent: {
            type: Boolean,
            default: function() {
                return true;
            }
        },
        /* 自动补全属性 */
        autocomplete: {
            type: String,
            default: function() {
                return 'new-password';
            }
        },
        /* 是否为按钮类型 */
        hasBtn: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        /* 是否有填充内容 */
        hasSolt: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        /* 填充内容 */
        fillContent: {
            type: String,
            default: function() {
                return '.png';
            }
        },
        /* 宽度设置 */
        width: {
            type: [Number, String],
            default: function() {
                return 200;
            }
        },
        /* 输入框头部图标 */
        prefixIcon: String,
        /* 输入框尾部图标 */
        suffixIcon: String,
        /* 控制是否能被用户缩放 */
        resize: String,
        /* 原生属性，自动获取焦点 */
        autofocus: Boolean,
        /* 输入框关联的label文字 */
        label: String,
        /* 输入框的tabindex */
        tabindex: String,
        /* 特殊字符验证 */
        specialCharacterCheck: {
            type: Boolean,
            default: false
        },
        /* 所有权限信息 */
        permissions: {
            type: Array,
            default: function() {
                return [];
            }
        },
        /* 角色信息 */
        roles: {
            type: Array,
            default: function() {
                return [];
            }
        },
        /* 权限之一 */
        oneOfPermissions: {
            type: Array,
            default: function() {
                return [];
            }
        }
    },
    data() {
        return {
            /* 是否满足显示权限 */
            permissionsShow: true,
            currentValue: {},
            isReadonly: false,
            vm: window.vue
        };
    },
    created() {
        /* 权限数据处理 */
        if (this.permissions.length > 0 || this.oneOfPermissions.length > 0 || this.roles.length > 0) {
            this.permissionsShow = this.dealPermissions(this.permissions, this.roles, this.oneOfPermissions);
        }
        this.currentValue = this.value;
        this.isReadonly = this.readonly;
    },
    watch: {
        value(newVal) {
            this.currentValue = newVal;
        },
        readonly(newVal) {
            this.isReadonly = newVal;
        }
    },
    methods: {
        _change(value) {
            let newValue = '';
            if (this.specialCharacterCheck && !this.$util.isEmpty(value) && typeof value == 'string') {
                let pattern = new RegExp("[`~!$^&*()=|{}';'\\[\\]<>?~！@#￥……&*（）——|{}【】‘；：’‘”“'。，、？]");
                for (let i = 0; i < value.length; i++) {
                    newValue = newValue + value.substr(i, 1).replace(pattern, '');
                }
                this.currentValue = newValue;
            } else {
                newValue = value;
            }
            // 实现数据向父组件的的实时传输
            this.$emit('input', newValue);
            /* 在值改变时触发,父组件可进行注册change方法 */
            this.$emit('change', newValue);
        },
        /* 组件失去焦点时触发，父组件可进行blur方法注册 */
        _blur(event) {
            this.$emit('blur', event);
        },
        /* 组件获得焦点时触发，父组件可进行focus方法注册 */
        _focus(event) {
            this.$emit('focus', event);
        },
        /* 在点击由 clearable 属性生成的清空按钮时触发，父组件可进行clear方法注册 */
        _clear() {
            this.$emit('clear');
        },
        /* 使 input 获取焦点 */
        focus() {
            this.$refs.input.focus();
        },
        /* 使 input 失去焦点 */
        blur() {
            this.$refs.input.blur();
        },
        /* 选中 input 中的文字 */
        select() {
            this.$refs.input.select();
        }
    }
};
</script>
